import type { ServerFileEntry } from "@mc/types"
import { apiRequest } from "./httpClient.js"

export function listServerFiles(serverId: string, path: string): Promise<{ path: string; entries: ServerFileEntry[] }> {
  return apiRequest(`/api/v1/servers/${serverId}/files?path=${encodeURIComponent(path)}`)
}

export function readServerFile(serverId: string, path: string): Promise<{ path: string; content: string | null }> {
  return apiRequest(`/api/v1/servers/${serverId}/files/content?path=${encodeURIComponent(path)}`)
}

export function writeServerFile(serverId: string, path: string, content: string): Promise<{ written: boolean }> {
  return apiRequest(`/api/v1/servers/${serverId}/files/content`, { method: "PUT", body: { path, content } })
}

export function deleteServerFile(serverId: string, path: string): Promise<void> {
  return apiRequest(`/api/v1/servers/${serverId}/files?path=${encodeURIComponent(path)}`, { method: "DELETE" })
}
